import {Component, h, Prop} from '@stencil/core';

@Component({
    tag: 'joy-spinner',
    styleUrl: 'spinner.scss',
    shadow: true,
})
export class JoySpinner {
    /** Spinner colors, 2 possible values but not any by default. Simply use css custom properties to customize */
    @Prop({reflect: true}) color?: 'teal' | 'white';

    private get spinnerColor() {
        return {['joy-spinner_' + this.color]: this.color};
    }

    render() {
        return (
            <div
                class={{
                    'joy-spinner': true,
                    ...this.spinnerColor,
                }}
            ></div>
        );
    }
}
